import { generateHash as baseGenerateHash } from "components/LocationStateManager/generateHash"
import { createStableObject } from "utils/stableObjectKeys"
import { type CustomChartConfigPayload } from "../types"

export function generateHash(config: CustomChartConfigPayload) {
  return baseGenerateHash(JSON.stringify(createStableObject(config)))
}
